import React, { useContext } from 'react';

import {
  InputLabel
} from 'components/form/prototypes';

import { useFormContext } from 'react-hook-form';
import { NCRContext } from "views";
import { UserContext } from 'components/routing'
import { Asterisk } from 'components/form/prototypes';

const ReturnAddress = () => {

  const { register } = useFormContext();
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled =
    ['QA', 'GM'].includes(user.role)
      ? state.ncr.status.id > 8
      : state.ncr.status.id > 1;

  let return_address_list = [
    {
      state_name: 'address_line_1',
      display_name: 'Address Line 1',
      ref: register({ required: true }),
      asterisk: true
    },
    { state_name: 'address_line_2', display_name: 'Address Line 2', ref: null },
    {
      state_name: 'address_city',
      display_name: 'City',
      ref: register({ required: true }),
      asterisk: true
    },
    {
      state_name: 'address_country',
      display_name: 'Country',
      ref: register({ required: true }),
      asterisk: true
    },
    {
      state_name: 'address_code',
      display_name: 'Region Code',
      code: true,
    },
    { state_name: 'address_postcode', display_name: 'Postcode/Zip Code', ref: null },
    { state_name: 'address_county', display_name: 'County/State (USA Only)', ref: null}
  ]

  return (return_address_list.map(({ state_name, display_name, ref, asterisk, code }) => {
    return (
      <>
      {asterisk &&
        <Asterisk/>
      }
      {code && 
        <InputLabel
        ref={ref}
        name={'ncr.order.address.' + state_name}
        label={display_name}
        key={'address_ncr_' + state_name + display_name}
        disabled={isDisabled || code} />
      }
      {!code &&
        <InputLabel
        ref={ref}
        name={'ncr.return.address.' + state_name}
        label={display_name}
        key={'address_ncr_' + state_name + display_name}
        disabled={isDisabled || code} /> 
      }
      </>
      )
  }));
}

export { ReturnAddress };
